export default class Calendar {
    id: number;
    dofid: number;
    campusID: number;
    termDatesID: number;
    schoolID: number;
    archiveGroupID: number;
    startDate: Date;
    endDate: Date;
    name: string;
    useMonday: boolean;
    useTuesday: boolean;
    useWednesday: boolean;
    useThursday: boolean;
    useFriday: boolean;
    useSaturday: boolean;
    useSunday: boolean;
    firstTimetableDayOrderNo: number;
    continuous: boolean;
    initialised: boolean;
    isPublished: boolean;
    version: string;
    createdOn: Date;
    createdBy: number;
    editedOn: Date;
    editedBy: number;
    recycledOn: Date;
    recycledBy: number;

    constructor(data: Partial<Calendar>) {
        Object.assign(this, data);

        this.startDate = this.startDate?.toDate();
        this.endDate = this.endDate?.toDate();
        this.createdOn = this.createdOn?.toDate();
        this.editedOn = this.editedOn?.toDate();
        this.recycledOn = this.recycledOn?.toDate();
    }
}
